export default __webpack_public_path__ + "static/logo-vaultstaking-ef05adab080a0b2cf1a710e5dd3226db.svg";